import { FormControl } from '@angular/forms';

export const WRITE_DATA_FRAME_PARAMETER_NAMES = {
  DATA_SOURCE: 'data source',
  OVERWRITE: 'overwrite',
  SAVE_MODE: 'Save mode (only for JDBC)',
} as const;

export interface WriteDataFrameTransitParameters {
  dataSourceId: string | null;
  overwrite: boolean | null;
  saveMode: WriteDataFrameTransitSaveMode | null;
}

export interface WriteDataFrameTransitFormGroup {
  dataSourceId: FormControl<string | null>;
  overwrite: FormControl<boolean | null>;
  saveMode: FormControl<WriteDataFrameTransitSaveMode | null>;
}

export interface WriteDataFrameTransitRawParameters {
  // Data source uuid
  [WRITE_DATA_FRAME_PARAMETER_NAMES.DATA_SOURCE]: string | null;
  [WRITE_DATA_FRAME_PARAMETER_NAMES.OVERWRITE]: boolean | null;
  [WRITE_DATA_FRAME_PARAMETER_NAMES.SAVE_MODE]: Partial<Record<WriteDataFrameTransitSaveMode, {}>> | null;
}

export const WriteDataFrameTransitSaveMode = {
  Append: 'Append',
  Overwrite: 'Overwrite',
  ErrorIfExists: 'ErrorIfExists',
  Ignore: 'Ignore',
  OverwriteTrancateTable: 'Overwrite (truncate table)',
} as const;

export type WriteDataFrameTransitSaveMode =
  (typeof WriteDataFrameTransitSaveMode)[keyof typeof WriteDataFrameTransitSaveMode];
